<template>
  <div>
    <!-- <div class="search_Content">
      <div
        class="search_Header"
        :style="
          isShowSeach ? 'height:65px;border-radius:10px 10px 0 0;' : 'background:#fff;'
        "
      >
        <div class="start_end">
          <div>Shenzhen</div>
          <img src="../../../../static/img/expressCheck/Group 13@2x.png" alt="" />
          <div>United States</div>
        </div>
        <div class="Commodity" v-if="!isShowSeach">
          Commodity：General Cargo (Non-Hazardous)
        </div>
      </div>
    </div>
    <el-collapse @change="handleChange">
      <el-collapse-item name="1" class="collapseContent">
        <template slot="title">
          <div class="checkPriceCondition">Edit Search</div>
        </template>
        <frontExpress></frontExpress>
      </el-collapse-item>
    </el-collapse> -->
    <div style="margin: 30px 0">
      <frontExpress :sortChose="DAPtype"></frontExpress>
    </div>
  </div>
</template>
<script>
import frontExpress from "./frontExpress.vue";
export default {
  components: {
    frontExpress,
  },
  data() {
    return {
      isShowSeach: false,
      DAPtype: "Comprehensive",
      TypeActived: 0,
      TypeList: [
        {
          lable: "DAP express",
          value: 0,
        },
        {
          lable: "DDP service",
          value: 1,
        },
      ],
      DAPactived: 0,
      DAPList: [
        {
          lable: "Comprehensive",
          value: 0,
        },
        {
          lable: "Cheapest",
          value: 1,
        },
        {
          lable: "Top-selling",
          value: 2,
        },
        {
          lable: "Quickest",
          value: 3,
        },
      ],
    };
  },
  methods: {
    handleChange(val) {
      if (val.length) {
        this.isShowSeach = true;
      } else {
        this.isShowSeach = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.search_Content {
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
  transition: height 0.3s;
  height: 85px;
}
.search_Header {
  background: #f9f9f9;
  border-radius: 10px;
  height: 85px;
  margin-top: 20px;
  padding: 13px 0 0 20px;
  box-sizing: border-box;
  transition: all 0.3s;

  .start_end {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    display: flex;
    align-items: center;
    img {
      width: 40px;
      height: 10px;
      margin: 0 15px 0 16px;
    }
  }
  .Commodity {
    height: 17px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #4a4a4a;
    margin-top: 11px;
    line-height: 17px;
  }
}
/deep/.el-collapse {
  border: none;
}
/deep/.collapseContent {
  .el-collapse-item__header {
    height: 0 !important;
  }
  .el-collapse-item__arrow {
    display: none !important;
  }
  .el-collapse-item__wrap {
    position: relative;
    top: -19px;
  }
}
.checkPriceCondition {
  position: absolute !important;
  left: 550px;
  top: 105px;
  background: #004fb1 !important;
  border-radius: 15px;
  width: 90px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: none;
  margin-left: 16px;
  cursor: pointer;
  font-size: 12px;
  font-family: MicrosoftYaHei;
  color: #ffffff;
}
.type_chose {
  height: 98px;
  background: #ffffff;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin-top: 15px;
  .type {
    display: flex;
    padding-top: 20px;
    box-sizing: border-box;
    div {
      width: 91px;
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      margin-left: 20px;
    }
    button {
      outline: none;
      border: none;
      width: 110px;
      height: 24px;
      background: #efefef;
      border-radius: 15px;
      font-size: 12px;
      font-family: MicrosoftYaHei;
      transition: background, color 0.2s;
      cursor: pointer;
      color: #777777;
      margin-left: 10px;
    }
  }
  .type_item {
    display: flex;
    margin-top: 10px;
    div:nth-of-type(1) {
      width: 91px;
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      margin-left: 20px;
      text-align: end;
    }
    button {
      cursor: pointer;
      outline: none;
      border: none;
      width: 100px;
      height: 24px;
      background: #efefef;
      border-radius: 15px;
      font-size: 12px;
      font-family: MicrosoftYaHei;
      transition: background, color 0.2s;

      color: #777777;
      margin: 0 0 0 10px;
    }
    button:nth-of-type(1) {
      width: 110px;
    }
    div:nth-of-type(2) {
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #d83f3f;
      line-height: 18px;
      margin-left: 15px;
    }
  }
}
.DAPactived {
  background: #004fb1 !important;
  color: #ffffff !important;
  transition: background, color 0.2s;
}
.TypeActived {
  background: #004fb1 !important;
  color: #ffffff !important;
  transition: background, color 0.2s;
}
</style>



// WEBPACK FOOTER //
// src/components/reception/express/index.vue